import { reactive, ref, computed } from '@vue/composition-api'

/**
 * ダッシュボードのウィジェットの設定UI
 */
export const getGroup = (props, context) => {

  const group1 = reactive({

    // 対象のウィジェットのタイプ
    widgetType: '',
    // 表示フラグ
    isVisible: computed(() => {
      return props.parentGroup1.isVisible
    }),
    // 表示件数
    count: computed(() => {
      return props.parentGroup1.count
    }),

    // 表示件数の選択肢表示フラグ
    isVisibleCountList: false,

    /**
     * 初期表示
     */
    init: () => {
      group1.widgetType = props.widgetType
      group1.currentCount = props.parentGroup1.count
    },

    /**
     * 表示/非表示の変更
     */
    changeVisible: () => {
      context.emit('changeVisible', { widgetType: group1.widgetType, isVisible: !props.parentGroup1.isVisible })
    },

    /**
     * 表示件数の変更
     */
    changeCount: (count) => {
      context.emit('changeCount', { widgetType: group1.widgetType, count: count })
    },

    /**
     * ウィジェット並び替えウィンドウを表示
     */
    openWidgetChangePositionWindow: () => {
      context.emit('openWidgetChangePositionWindow', { widgetType: props.widgetType })
    }

  })

  return group1
}
